import { Content } from '../../types'

export enum ContentSizeEnum {
  Small = 'small',
  Large = 'large', // default
}

export type ContentSize = `${ContentSizeEnum}`

export interface ContentBlock {
  content: Content[]
  slideshow?: boolean
  autoPlay?: boolean
  autoplayDelay?: number
  size?: ContentSize
}
